import { Subject, Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';

export type GetDataHandler<T> = () => Observable<T>;

export class Cacheable<T> {

    protected isLoaded = false;
    protected data: T;
    protected originalDataJson: string;
    protected subjectData: Subject<T>;
    protected observableData: Observable<T>;
    public getHandler: GetDataHandler<T>;
    public hasChanges = false;
    
    constructor() {
        this.subjectData = new ReplaySubject(1);
        this.observableData = this.subjectData.asObservable();
    }

    public getData(): Observable<T> {
        if (!this.getHandler) {
            throw new Error("getHandler is not defined");
        }

        if (!this.data) {
            this.getHandler().pipe(map((r: T) => {
                this.data = r;
                this.originalDataJson = JSON.stringify(r);
                this.isLoaded = true;

                return r;
            })).subscribe(
                result => this.subjectData.next(result),
                err => this.subjectData.error(err)
            );
        }

        return this.observableData;
    }

    public resetCache(): void {
        this.data = null;
    }

    public refresh(): void {
        this.resetCache();
        this.getData();
    }

    public checkForChanges(): void {
        if (!this.isLoaded) {
            return;
        }

        this.hasChanges = JSON.stringify(this.data) !== this.originalDataJson;
    }
}
